export default __webpack_public_path__ + "static/media/question-mark.inline.c882395e.svg";